import {RAKE_RACE_TABS} from "../../../constants/index.jsx";
import TabItem from "../Tabs/TabItem/TabItem.jsx";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import RakeRaceInfo from "./RakeRaceContents/RakeRaceInfo.jsx";
import {useSelector} from "react-redux";
import RakeRaceLeaderBoard from "./RakeRaceContents/RakeRaceLeaderBoard.jsx";

function RakeRace() {
    const rakeRace = useSelector((state) => state.lobby.rakeRace);
    const lang = useSelector((state) => state.user.lang);
    const [selectedTabIndex, setTabIndex] = useState(0);
    const {t} = useTranslation();

    const toggleTab = (index) => {
        setTabIndex(index);
    }
    const renderTable = () => {
        if (selectedTabIndex === 2) return
        const tableData = selectedTabIndex === 0 ? rakeRace?.progress : rakeRace?.finished;
        const firstData = tableData?.leaderBoard
            ?.filter(item => item?.count >= tableData?.minRoomCount)
            ?.sort((a, b) => {
                if (a.points !== b.points) {
                    return b.points - a.points;
                }
                return b.count - a.count;
            }) || [];
        const secondData = tableData?.leaderBoard
            ?.filter(item => item?.count < tableData?.minRoomCount)
            ?.sort((a, b) => {
                if (a.count !== b.count) {
                    return b.count - a.count;
                }
                return b.points - a.points;
            }) || [];
        const board = firstData?.concat(secondData);
        return (
            board?.length > 0 ?
                <RakeRaceLeaderBoard rows={board} prizePool={tableData?.prizePool} minRoomCount={tableData?.minRoomCount}/>
                : <p className="rake-race__empty-text">{t("rake_race.empty")}</p>)
    }

    return (
        <div className="rake-race">
            <img src={rakeRace?.information?.[lang]?.img} className="rake-race__image" alt="rake-race"/>
            <div className="rake-race__tabs">
                <div className={`tabs tabs--${RAKE_RACE_TABS?.length}`}>
                    {
                        RAKE_RACE_TABS?.map((item, index) => {
                            return <TabItem
                                key={index}
                                item={t(`tabs.${item}`)}
                                onClick={() => {
                                    toggleTab(index)
                                }}
                                active={selectedTabIndex === index}
                            />
                        })
                    }
                    {<span className={`toggle active-${selectedTabIndex + 1}`}></span>}
                </div>
            </div>
            <div className="rake-race__content">
                {renderTable()}
                {selectedTabIndex === 2 && <RakeRaceInfo
                    content={rakeRace?.information?.[lang]?.html}/>}
            </div>
        </div>
    )
}

export default RakeRace